<template>
  <!-- NOTE: 1日の幅一杯の休息バーが表示されれればいいので日付は適当 -->
  <BreakBar end="2022-01-01 23:59:00" title="休日" />
</template>

<script lang="ts">
export default defineComponent({})
</script>
